export enum BroadcastCreateFieldEnum {
  name = 'name',
  smsMessage = 'smsMessage',
  ringlessMessage = 'ringlessMessage',
  sendFrom = 'sendFrom',
  contacts = 'contacts',
  conversion_id = 'conversion_id',
  attachment_limit = 'attachment_limit',
  file_size_limit = 'file_size_limit',
  chatbot_id = 'chatbot_id',
}

export type IBroadcastCreateField = `${BroadcastCreateFieldEnum}`

export type IEstimatedDateProps = {
  hubspotList: number
  integrationMergeFields: number
  general: number
  total: number
} | null

export enum EnumModeBroadcast {
  Create = 'create',
  Clone = 'clone',
  Edit = 'edit',
}

export enum EnumTypeBroadcast {
  Sms = 'sms',
  Ringless = 'ringless',
  Rcs = 'rcs',
}
